// Vendors
import { StorageLocalEnumeration } from '@gruposantander/opbpay-ui-core-models';
// Constants
import { CURRENT_LOCALE_KEY } from '../constants/internationalization.handlers.constants';
// Types
import { InternationalizationRegisterTranslationProviderType } from '../../types/internationalization-register-translation.provider.type';

const versionHasChanged = (version: string): boolean =>
  localStorage.getItem(StorageLocalEnumeration.VERSION) !== version;

const languageHasChanged = (language: string): boolean =>
  localStorage.getItem(CURRENT_LOCALE_KEY) !== language;

const newTranslationsVersionAvailable = ({
  language,
  lastChangedVersion,
}: InternationalizationRegisterTranslationProviderType): boolean =>
  Boolean(
    localStorage.getItem(StorageLocalEnumeration.TRANSLATIONS) === null ||
      versionHasChanged(lastChangedVersion) ||
      languageHasChanged(language)
  );

export { newTranslationsVersionAvailable };
